import Vue from 'vue';
import Router from 'vue-router';

import LoginIndex from './views/login/Index.vue';

import Advertisers from './views/Advertisers.vue';
import Publishers from './views/Publishers.vue';
import Campaign from './views/Campaign.vue';
import Campaigns from './views/Campaigns.vue';
import Healthcheck from './views/Healthcheck.vue';
import NotFound from './views/NotFound.vue';

import store from './store';


Vue.use(Router);

// TODO: julius - refactor router logic
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'loginIndex',
      component: LoginIndex,
      props: true,
    },
    {
      path: '/reset',
      name: 'loginReset',
      component: () => import('./views/login/Reset.vue'),
    },
    {
      path: '/update',
      name: 'loginUpdate',
      component: () => import('./views/login/Update.vue'),
    },
    {
      path: '/thanks',
      name: 'loginThanks',
      component: () => import('./views/login/Thanks.vue'),
      props: true,
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('./views/login/Logout.vue'),
    },
    {
      path: '/advertisers',
      name: 'advertisers',
      component: Advertisers,
      props: true,
    },
    {
      path: '/publishers',
      name: 'publishers',
      component: Publishers,
      props: true,
    },
    {
      path: '/advertisers/:advertiserLabel',
      redirect: '/advertisers/:advertiserLabel/campaigns',
    },
    {
      path: '/advertisers/:advertiserLabel/campaigns',
      name: 'campaigns',
      component: Campaigns,
      beforeEnter: (to, from, next) => {
        const advertiser = store.state.advertisers
          .find(advertiser => advertiser.label === to.params.advertiserLabel);

        if (typeof advertiser === 'undefined') {
          return next('/404');
        }

        next();
      },
    },
    {
      path: '/advertisers/:advertiserLabel/campaigns/:campaignLabel',
      name: 'campaignByLabel',
      component: Campaign,
      beforeEnter: (to, from, next) => {
        const advertiser = store.state.advertisers
          .find(advertiser => advertiser.label === to.params.advertiserLabel);

        if (typeof advertiser === 'undefined') {
          return next('/404');
        }

        const { campaigns } = advertiser;
        const campaign = campaigns
          .find(campaign => campaign.label === to.params.campaignLabel);

        if (typeof campaign === 'undefined') {
          return next('/404');
        }

        next();
      },
    },
    {
      path: '/healthcheck',
      name: 'healthcheck',
      component: Healthcheck,
    },
    {
      path: '*',
      redirect: '/404',
    },
    {
      path: '/404',
      name: 'notFound',
      component: NotFound,
    },
  ],
});

export default router;
